import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/images/logo1.png';
import '../assets/css/style.css';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ onQuoteClick }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navClassName = ({ isActive }) => `nav-link${isActive ? ' active' : ''}`;

  const toggleNavbar = () => setIsCollapsed(!isCollapsed);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const { isAuthenticated, user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.accountType === 'admin';

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark foi-navbar professional-navbar">
        <div className="container professional-navbar-inner">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="Financial Experts" height="56" />
          </Link>

          <button
            className="navbar-toggler d-lg-none"
            type="button"
            onClick={toggleNavbar}
            aria-expanded={!isCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${!isCollapsed ? 'show' : ''}`}
            id="collapsibleNavId"
          >
            <ul className="navbar-nav ml-auto mt-2 mt-lg-0 main-nav-group">
            <li className="nav-item">
              <NavLink className={navClassName} to="/" end>
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className={navClassName} to="/about">
                About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className={navClassName} to="/services">
                Our Services
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className={navClassName} to="/gallery">
                Gallery
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className={navClassName} to="/courses">
                Courses
              </NavLink>
            </li>

            <li className={`nav-item dropdown ${dropdownOpen ? 'show' : ''}`}>
              <a
                className="nav-link dropdown-toggle"
                id="pagesMenu"
                aria-expanded={dropdownOpen}
                onClick={toggleDropdown}
                style={{ cursor: 'pointer' }}
                href="#!"
              >
                See More
              </a>

              <div
                className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}
                aria-labelledby="pagesMenu"
              >
                <Link className="dropdown-item" to="/blog">
                  News and Events
                </Link>
                <Link className="dropdown-item" to="/publication">
                  Publication
                </Link>
                <Link className="dropdown-item" to="/contact">
                  Contact
                </Link>
                <Link className="dropdown-item" to="#">
                  Careers
                </Link>
                <a
                  className="dropdown-item"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfOJu8ZO5lPNXmaASFaKiyPWUkHW-PHgZCsQ8bEA7SRlphIWA/viewform?usp=dialog"
                >
                  Training
                </a>
              </div>
            </li>
            </ul>

            <ul className="navbar-nav mt-2 mt-lg-0 header-cta-group">
              {isAuthenticated && !isAdmin && (
                <li className="nav-item">
                  <NavLink className={navClassName} to="/student/dashboard">
                    My Dashboard
                  </NavLink>
                </li>
              )}

              {isAdmin && (
                <>
                  <li className="nav-item">
                    <NavLink className={navClassName} to="/admin/lms">
                      LMS Admin
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={navClassName} to="/admin/courses">
                      Courses
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={navClassName} to="/admin/lms-enrollments">
                      Enrollments
                    </NavLink>
                  </li>
                </>
              )}

              <li className="nav-item">
                <button
                  className="btn btn-secondary btn-quote"
                  onClick={onQuoteClick}
                  type="button"
                >
                  Quote
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="site-header-spacer" aria-hidden="true"></div>
    </>
  );
};

export default Navbar;
